import { CoreModule, InputModule, KeyValueStoreModule, VinylPostcardsModule, ARModule, SceneModule, WebviewModule} from "./modules";
import { JsonRpcChannel } from '../jrpc/channel';

export interface UnityApi {
    core: CoreModule;
    input: InputModule;
    keyValueStore: KeyValueStoreModule;
    vinylPostcards: VinylPostcardsModule;
    ar: ARModule;
    scene: SceneModule;
    webview: WebviewModule;
}

export const createUnityApi = (channel: JsonRpcChannel): UnityApi => ({
    core: new CoreModule(channel),
    input: new InputModule(channel),
    keyValueStore: new KeyValueStoreModule(channel),
    vinylPostcards: new VinylPostcardsModule(channel),
    ar: new ARModule(channel),
    scene: new SceneModule(channel),
    webview: new WebviewModule(channel)
})
